// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {Modulo} from "services-translation/modules/base/modulo";

import {TraduccionCmpAutoAcceptWindowAawMainMessage, TraduccionCmpAutoAcceptWindowAawMainMessageParams} from "./auto_accept_window/aaw_main_message";
import {TraduccionCmpAutoAcceptWindowAawOpenConfig} from "./auto_accept_window/aaw_open_config";

export class TraduccionCmpAutoAcceptWindow extends Modulo {
    /* STATIC */
    // public static ID: string = "cmp.auto_accept_window";
    // public static VERSION: Date = new Date("2024-03-25T07:41:46.205Z");
    // public static HASH: string = "1c514ada12d726984b05d53000d5ca35";

    private static CACHE: {[lang: string]: TraduccionCmpAutoAcceptWindow} = {};

    public static build(lang: IIdioma): TraduccionCmpAutoAcceptWindow {
        return this.CACHE[lang.idioma] ??= new this(lang);
    }

    /* INSTANCE */
    public aaw_open_config: string;

    #aaw_main_message: TraduccionCmpAutoAcceptWindowAawMainMessage;

    private constructor(_lang: IIdioma) {
        super(_lang);

        this.#aaw_main_message = TraduccionCmpAutoAcceptWindowAawMainMessage.build(this._lang);
        this.aaw_open_config = TraduccionCmpAutoAcceptWindowAawOpenConfig.build(this._lang).toString();
    }

    public aaw_main_message(params: Partial<TraduccionCmpAutoAcceptWindowAawMainMessageParams> = {}) {
        return this.#aaw_main_message.render(params);
    }
}

export default (lang: IIdioma)=>TraduccionCmpAutoAcceptWindow.build(lang);
